import React, { useCallback, useEffect, useRef,useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router";
import { Box } from "@mui/material";
import moment from "moment";
import LmsKitLabel from "../../components/features/LmsKitLabel";
import SkeletonLoader from "../../../utilites/SkeltonLoader";
import ProgressTracker from "../../components/common/ProgressTracker";
import { fetchV2V, selectActiveV2VCycle, selectAllInitialSteps, selectCurrentCycle } from "../../slices/common";
import { hasAuthority } from "../../../utils/authorities";
import { getPatientDetailsById } from "../../slices/QRCode";
import { setSlugs } from "../../slices/help";
import { addPatientList, addPhaseList } from "../../slices/chat";
import ChatModule from "../Chat";
import FailedManufacturingForm from "../../components/common/ProgressTracker/FailedManufacturingForm";
import RestartManufacturingForm from "../../components/common/ProgressTracker/RestartManufacturingForm";
import {
  productCompleteManufacturing,
  markedAsAccpetManufacturing,
} from "../../slices/manufacturer";
import ManufacturingForm from "../../components/features/ManufacturingForm";
import InBoundForm from "../../../pages/appointment-details/InBoundForm";
import LSMApproval from "./Common/lsmApproval";
import CryopeserveLsmModal from "../../components/features/ManufacturingForm/Common/CryopeserveLsmModal";
import CryoLsmFormDialog from "../../components/features/ManufacturingForm/Common/CryoLsmFormDialog";
// import { selectIsLoading } from "../../slices/carTForm";
// import BsModal from "../../components/common/BaseModal";
import BreadCrumb from "../../../pages/breadcrumb/BreadCrumb"
import BsModal from '../../components/common/BaseModal';
import CryopeserveView from  "../../components/features/ManufacturingForm/Common/CryopeserveView"
import { volumnBagList, selectDynamicBags } from "../../slices/manufacturer";
import { urlToBackWithoutState } from "../../../utilites/Common";
import { useReactToPrint } from 'react-to-print';
import ManufacturingLabelPrint from "./ManufacturingLabelPrint ";

const ManufacturerView = () => {
  const { id } = useParams();
  const location = useLocation();
  const [breadCrumbArray] = useState(
    urlToBackWithoutState(location.pathname, location?.state)
  );
  const printTimeoutRef = useRef(null);

  // const isLoading = useSelector(selectIsLoading)
  const currentCycle = useSelector(selectCurrentCycle)
  const dispatch = useDispatch();
  const [patientInfo, setPatientInfo] = useState({});
  const [patientData, setPatientData] = useState({});
  const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
  //const [printPatientInfo, setPrintPatientInfo] = useState({});
  const [bagCount, setBagCount] = useState(0);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const [timeLineSkeletonLoading, setTimeLineSkeletonLoading] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [status, setStatus] = useState(0);
  const [formProps, setFormProps] = useState(undefined);
  const [cryoModal, setCryoModal] = useState(false)
  const [cryoModalDailog,setCryoModalDailog] = useState(false)
  const bagDynamic = useSelector(selectDynamicBags)

  const qrRef = useRef(null);
  const printContentRef = useRef(null);
  
  const allInitialSteps = useSelector(selectAllInitialSteps)
  const activeV2VCycle = useSelector(selectActiveV2VCycle) || 0
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const role_slug = LoginData.role_slug; 

  const reactToPrintFn = useReactToPrint({
    content: () => printContentRef.current,
    onAfterPrint: () => {
    },
  });


  const canShowCartForm = useMemo(() => {
    const manufacturingStep = allInitialSteps?.find(op => op.slug === "product-manufactured");
    return manufacturingStep?.status !== 8 && manufacturingStep?.status !== 6 && manufacturingStep?.status !== 3 && manufacturingStep?.status >= 1 &&
      hasAuthority(["manufacturing-approve", "start-manufacturing"], bmr_permissions);
  }, [allInitialSteps, bmr_permissions]);

    const canShowCryoForm = useMemo(() => {
    const manufacturingStep = allInitialSteps?.find(op => op.slug === "product-manufactured");
    return manufacturingStep?.status > 0 && manufacturingStep?.status != 8  &&
      hasAuthority(["manufacturing-approve", "start-manufacturing"], bmr_permissions);
  }, [allInitialSteps, bmr_permissions]);

  const fetchPatientInfo = async () => {
    try {
      if (window.qrGenerationTimeout) {
        clearTimeout(window.qrGenerationTimeout);
        window.qrGenerationTimeout = null;
      }
      
      const patientDetailsResponse = await dispatch(
        getPatientDetailsById(id)
      ).unwrap();
      
      
      const patientDetails = patientDetailsResponse?.data?.patient_information;
      const isBagCount = patientDetailsResponse?.data?.number_of_bags || 0;
      
      setBagCount(isBagCount);
      
      if (patientDetailsResponse?.data) {
        // Set printPatientInfo with the full API response
       // setPrintPatientInfo(patientDetailsResponse.data);
        
        // Set patientData for ManufacturingLabelPrint
        setPatientData(patientDetailsResponse.data);
        
        const patientBasicInfo = {
          patientName: patientDetails?.name || "-",
          patientId: patientDetails?.patient_id || "-",
          id: patientDetails?.id,
          subject_id: patientDetails?.subject_id || patientDetails?.id,
          feasibility_assessment_id:
            currentCycle?.feasibility_assessments_id || patientDetails?.feasibility_assessment_id,
          inbond_form_id: currentCycle?.inbond_patients_id ?? null,
            hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
          logisticOperationId:
            patientDetailsResponse?.data?.logistics_operation_id ?? null,
          immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
          name: patientDetails?.name || "-", // Add name for ReprintComponent
          body_weight: patientDetails?.body_weight || 0, // Add weight for ReprintComponent
          dob: patientDetails?.dob || "-", // Add DOB for ReprintComponent
          disease: patientDetails?.disease || "-", // Add disease for ReprintComponent
          hospital: patientDetails?.hospital || "-", // Add hospital for ReprintComponent
        };
        
        const patientMedicalRecord = {
          "Patient Body Weight": `${patientDetails?.body_weight} Kg` || "-",
          "Disease Indication": patientDetails?.disease || "-",
          "Date of Birth": patientDetails?.dob
            ? moment(patientDetails.dob).format("DD/MM/YYYY")
            : "-",
          "Hospital Name": patientDetails?.hospital || "-",
          "Hospital Patient ID": patientDetailsResponse?.data?.hospital_patient_id || "-",
          "Ship & Store": "≤ -80 degrees",
          "Total no Bags": isBagCount,
          "Batch ID": currentCycle?.batch_no || patientDetailsResponse?.data?.batch_no || "-",
        };

        setPatientInfo(patientBasicInfo);
        setPatientMedicalInfo(patientMedicalRecord);
        setFormProps({
          subject_id: patientBasicInfo.subject_id,
          feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
          car_t_form_id: currentCycle?.car_t_manufacturing_form_id,
          product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
          inbound_patient_id: currentCycle?.inbond_patients_id,
          qr_code_generated_id: id,
        });

        // Generate QR code
        window.qrGenerationTimeout = setTimeout(() => {
          const canvas = qrRef.current?.querySelector('canvas');
          if (canvas) {
            const dataUrl = canvas.toDataURL('image/png');
            setQrCodeDataUrl(dataUrl);
          }
          window.qrGenerationTimeout = null;
        }, 1000);
      }
    } catch (error) {
      console.error("Error fetching patient info:", error);
    }
  };

  const handlePrint = async () => {
  //  await fetchPatientInfo();
 // Clear previous timeout
  if (printTimeoutRef.current) {
    clearTimeout(printTimeoutRef.current);
    printTimeoutRef.current = null;
  }
    const printDataObj = {
      printPatientInfo: patientData,
      qrCodeDataUrl,
      bagCount: 1,
      printCount: 1,
      printSingleBag: null,
      patientMedicalInfo,
    };

    setPrintData(printDataObj);
     // Delay to ensure DOM updates before print
    printTimeoutRef.current = setTimeout(() => {
      reactToPrintFn();
      printTimeoutRef.current = null;
    }, 300);
  };

useEffect(() => {
  return () => {
    if (printTimeoutRef.current) {
      clearTimeout(printTimeoutRef.current);
    }
  };
}, []);

  // Manual QR code generation if needed
  useEffect(() => {
    if (patientInfo?.id && !qrCodeDataUrl) {
      const timer = setTimeout(() => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (canvas) {
          const dataUrl = canvas.toDataURL('image/png');
          setQrCodeDataUrl(dataUrl);
        }
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [patientInfo, qrCodeDataUrl]);

  useEffect(() => {
    if (!formProps?.product_manufacturing_stages_id && currentCycle?.product_manufacturing_id) {
      setFormProps((prev) => ({
        ...prev,
        product_manufacturing_stages_id: currentCycle.product_manufacturing_id,
      }));
    }
    const manufacturingStep = currentCycle?.data?.find(
      (step) => step.slug === "product-manufactured"
    );
    setStatus(manufacturingStep?.status || 0);
  }, [currentCycle]);

const fetchBagsList = useCallback(
  async (id) => {
    const assessmentId = id ?? currentCycle?.feasibility_assessments_id;
    if (!assessmentId) return;
    try {
      await dispatch(volumnBagList(assessmentId)).unwrap();
    } catch (err) {
      console.error("Error fetching bags list:", err);
    }
  },
  [dispatch, currentCycle?.feasibility_assessments_id]
);
  // Updated timeline function with corrected workflow logic
  const getTimeLine = async (patientId) => {
    setTimeLineSkeletonLoading(true);
    try {
      const res = await dispatch(
        fetchV2V({ portal_type: 2, patient_id: patientId ?? patientInfo?.id })
      ).unwrap();
      if (res?.status == 200) {
        const stepData = res.data;
        const manufacturingStep = stepData[activeV2VCycle]?.data?.find(
          (step) => step.slug === "product-manufactured"
        );
        setStatus(manufacturingStep?.status || 0);
        fetchBagsList(stepData[activeV2VCycle]?.feasibility_assessments_id)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setTimeLineSkeletonLoading(false);
    }
  };

  useEffect(() =>{
    fetchBagsList(currentCycle?.feasibility_assessments_id)
  },[currentCycle?.feasibility_assessments_id])

  // Start manufacturing function
  const startManufacture = async (step) => {
    try {
      let res = null
      if (step.slug == "accept-manufacturing") {
        res = await dispatch(markedAsAccpetManufacturing(currentCycle?.feasibility_assessments_id)).unwrap();
      }
      if (res?.status == 200) {
        getTimeLine(patientInfo?.id);
      }
    } catch (err) {
      console.error("Error starting manufacturing:", err);
    }
  };

  // Handle complete manufacturing
  const handleCompleteManufacturing = async () => {
    try {
      const payload = {
        subject_id: patientInfo?.subject_id || patientInfo?.id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
        qr_code_generated_id: id,
      };

      const res = await dispatch(
        productCompleteManufacturing(payload)
      ).unwrap();
      if (res?.status == 200) {
        getTimeLine(patientInfo?.id);
        fetchPatientInfo();
      }
    } catch (err) {
      console.error("Error completing manufacturing:", err);
    }
  };

  // Handle when LSM is marked shipped
  const handleLSMMarkedShipped = () => {
    getTimeLine(patientInfo?.id);
    fetchPatientInfo();
  };

  useEffect(() => {
    fetchPatientInfo();
  }, [id]);


useEffect(() => {
  if (currentCycle?.batch_no) {
    setPatientData(prev => ({
      ...prev,
      batch_no: currentCycle.batch_no
    }));
  }
}, [currentCycle]);

  // Get Timeline when component mounts
  useEffect(() => {
    const patientId = patientInfo?.id;
    if (patientId) {
      getTimeLine(patientId);
    }
  }, [patientInfo?.id]);

  useEffect(() => {
    if (hasAuthority(["product-manufacturing-process"], bmr_permissions)) {
      dispatch(
        setSlugs([
          "start-manufacturing",
          "failed-manufacturing",
          "completed-manufacturing",
        ])
      );
    }
    return () => {
      dispatch(setSlugs([""]));
    };
  }, [id]);

  ////////// phase and patient List for chat bot ///////////
  useEffect(() => {
    if (patientData?.patient_information) {
      const phaseList = [
        {
          value: patientData?.patient_information?.phase_id,
          label: `${patientData?.phase_name} (${patientData?.product_name})`,
          patient_id: patientData?.patient_information?.id,
        },
      ];
      const patientList = [
        {
          value: patientData?.patient_information?.id,
          label: `${patientData?.patient_information?.name}`,
          phase_id: patientData?.patient_information?.phase_id,
        },
      ];
      dispatch(addPatientList(patientList));
      dispatch(addPhaseList(phaseList));
    }
  }, [patientData]);

  const handleCryoModal = () => {
    setCryoModal(true)
  }

  return (
    <Box>
      <Box container className="mt-4 ml-3 mr-3 mainDiv">
        <BreadCrumb BreadCrumbsListing={breadCrumbArray} />
        
        
        <LmsKitLabel
          screenType={['superadmin', 'logistics-management', 'manufacture']?.includes(role_slug) ? 'qr-code' : "logistics"}
          patientInfo={patientInfo}
          bagCount={bagCount}
          patientMedicalInfo={patientMedicalInfo}
          qrCodeId={id}
          handlePrint={handlePrint}
          getTimeLine={() => getTimeLine(patientInfo?.id)}
        />
        
      </Box>
      
      <Box container className="mt-4 ml-3 mr-3 pb-3 mainDiv">
        {timeLineSkeletonLoading ? (
          <SkeletonLoader rowCount={1} height={80} isTable={false} />
        ) : (
          <ProgressTracker
            FormComponent={
              status == 4
                ? FailedManufacturingForm
                : status == 3
                  ? RestartManufacturingForm
                  : (status == 4 || status == 6 || status == 0)
                    ? LSMApproval
                    : ""
            }

            steps={allInitialSteps}
            onAction={
              status == 4 ? handleCompleteManufacturing : startManufacture
            }
            onUpdate={handleLSMMarkedShipped}
            formProps={{
              ...formProps,
              handleCryoSubmitTask: handleCryoModal
            }}
            patient_id={patientInfo?.id}
            buttonPop={['product-manufactured','start-manufacturing']}
            onDirectPrint={handlePrint}
          />
        )}
      </Box>

      {
        canShowCryoForm &&
        <Box className="mt-4 ml-3 mr-3 pb-3">
          <CryopeserveView
            patientData={patientData}
            patientInfo={patientInfo}
            patientMedicalInfo={patientMedicalInfo}
            bagCount={bagCount}
            formProps={formProps}
            bagDynamic={bagDynamic}
            getTimeLine={getTimeLine}
          />
        </Box>
      }
      
      {
        canShowCartForm &&
        <Box className="mt-4 ml-3 mr-3 pb-3">
          <ManufacturingForm
            patientData={
              {
                ...patientInfo,
                ...patientData,
              }}
            fetchPatientInfo={fetchPatientInfo}
            initialSteps={allInitialSteps}
            updateTimeLine={getTimeLine}
          />
        </Box>
      }
      {
        patientInfo?.inbond_form_id && (
          <Box className="mt-4 ml-3 mr-3 pb-3">
            {timeLineSkeletonLoading ? (
              <SkeletonLoader rowCount={1} height={80} isTable={false} />
            ) : (
              <InBoundForm patientData={
                {
                  ...patientInfo,
                  ...patientData,
                  qrCode_id: id,
                  feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
                  inbond_form_id: currentCycle?.inbond_patients_id,
                  patient_id: patientData?.patient_information?.id
                }}
                initialSteps={allInitialSteps}
                updateTimeLine={getTimeLine}
              />
            )}
          </Box>
        )
      }
      <CryopeserveLsmModal open={cryoModal} setOpen={setCryoModal} setOpenModal={setCryoModalDailog} />
      <BsModal title={'Cryopeserve LSM'} open={cryoModalDailog} size={'md'} setOpen={setCryoModalDailog} fullWidth={true}>
        <CryoLsmFormDialog  id={patientInfo?.id} setOpen={setCryoModalDailog} formProps={formProps} getTimeLine={getTimeLine}/>
      </BsModal>
      
      {/* Reprint Component Modal - Fixed to use reprintData */}
     
     
      {printData && (
        <div style={{ display: "none" }}>
          <ManufacturingLabelPrint
            ref={printContentRef}
            printData={printData}
          />
        </div>
      )}
      <ChatModule />
    </Box>
  );
};

export default ManufacturerView;